import React from 'react';
import { handleLogout } from 'services/auth';
import userIcon from 'assets/img/brand/favicon.png';
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Navbar,
  Nav,
  Container,
} from 'reactstrap';

import firebase from '../../../libs/firebase';

const AdminNavbar = () => {
  return (
    <>
      <Navbar
        className="navbar-top navbar-expand border-bottom navbar-dark"
        expand="lg"
        id="navbar-main"
      >
        <Container fluid>
          <Collapse
            isOpen
            navbar
          >
            <Nav
              className="align-items-center ml-md-auto"
              navbar
            />
            <Nav
              className="align-items-center ml-auto ml-md-0"
              navbar
            >
              <UncontrolledDropdown nav>
                <DropdownToggle
                  className="nav-link pr-0"
                  color=""
                  tag="a"
                >
                  <Media className="align-items-center">
                    <span className="avatar avatar-sm rounded-circle">
                      <img
                        alt="user"
                        src={userIcon}
                      />
                    </span>
                    <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {firebase.auth().currentUser?.email}
                      </span>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem
                    href="#pablo"
                    onClick={handleLogout}
                  >
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
